export const financingOfferLogos = [
  {
    index: 0,
    name: 'synchrony',
    url: '/makeapayment/icons/payment-connector/synchrony-logo.svg',
  },
  {
    index: 1,
    name: 'affirm',
    url: '/makeapayment/icons/payment-connector/affirm.svg',
  },
  {
    index: 2,
    name: 'progresive',
    url: '/makeapayment/icons/payment-connector/progressive-min.svg',
  },
];
export const analyticsConstants = {
  pageName: 'cart',
  componentName: 'offersection',
  buttonNameSyf: 'synchrony',
  buttonNameAff: 'affirm',
  buttonNameProg: 'progressive',
};
export const analyticsConstantsDrawer = {
  pageName: 'cart',
  componentName: 'sidedrawer',
  buttonName: 'allfinancing',
};
